import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import cn from "classnames";
import ImageOrVideo from "../Widgets/ImageOrVideo"
import Caption from "../Widgets/Caption"
import RichTextContainer from "../Widgets/RichTextContainer"
import ShopTheLookCarousel from '../ShopThLook/ShopTheLookCarousel'
import map from 'lodash/map'
import CentredContentContainer from "../Widgets/CentredContentContainer"

const MAX_IMAGE_WIDTH = 420;

class ShopTheLookSlice extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {image, image_size, video, title, copy, caption, shop_the_look_title, shopItems, image_location} = item;

        const id = map(shopItems, x => x.sku).join(',');

        const renderTitleAndCopy = () => {
          return <React.Fragment>
            {title && <h2 className={cn(classes.title, classes.titleDesktop)} >{title.text}</h2>}
            {copy && <RichTextContainer className={classes.body} content={copy} removeBottomMargin={false} />}
          </React.Fragment>
        }

        const renderShopItems = ({ size } = {}) => {
          return shopItems ? (
            <ShopTheLookCarousel
              className={classes.productsContainer}
              shopItems={shopItems}
              id={id}
              groupCells={true}
              showNextPrevButtons={shopItems.length <= 5 ? false : true}
              overflow={false}
              size={size}
              title={shop_the_look_title}
              isMobile={true}
            />
            ) : null
        }

        const renderImage = ({ aspect } = {}) => {
          return (
            <div className={classes.imageContainer}>
                { ((image && image.desktop) || video) &&
                <div className={classes.image}>
                    {title && <h2 className={cn(classes.title, classes.titleMobile)} key="title">{title.text}</h2>}
                    <ImageOrVideo images={image}
                                  video={video}
                                  aspect={aspect}
                                  sizes={`min-width: ${image_size || MAX_IMAGE_WIDTH}px ${image_size || MAX_IMAGE_WIDTH}px, 100vw`}
                                  caption={caption}>
                    </ImageOrVideo>
                    {caption && <Caption key="caption" caption={caption}></Caption>}
                </div>
                }
            </div>
          )
        }

        if(image_location === 'Above') {
          return (
              <CentredContentContainer className={classes.imageAboveContainer}>
                <section className={classes.imageAbove}>
                  <div className={cn(classes.verticalContainer, classes.dynamicWidth)} >
                    {renderTitleAndCopy()}
                    {renderImage()}
                    {renderShopItems({ size: 'medium' })}
                  </div>
                </section>
              </CentredContentContainer>
          )
        }

        return (
          <CentredContentContainer>
            <section>
              <div className={classes.container} >
                <div className={cn(classes.column, classes.imageColumn)}>
                  {renderImage()}
                </div>
                <div className={classes.column}>
                  <div className={classes.contentContainer}>
                    {renderTitleAndCopy()}
                    {renderShopItems({ size: 'medium' })}
                  </div>
                </div>
              </div>
            </section>
          </CentredContentContainer>
        )
    }
}

export default injectSheet((theme) => ({
  verticalContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: MAX_IMAGE_WIDTH * 2,
    margin: 'auto',
    '& $imageContainer': {
      margin: [0, 'auto', '2rem'],
      maxWidth: 630,
      width: '100%'
    },
    '& $titleDesktop': {
      display: 'block'
    },
    '& $titleMobile': {
      display: 'none'
    }
  },
  container: {
      display: "block",
      [theme.breakpoint("tablet")]: {
          display: "flex",
          flexDirection: ({item: {image_location}}) => image_location === 'Right' ? "row-reverse" : "row",
      },
  },
  column: {
      flexBasis: "50%"
  },
  imageColumn: {
      zIndex: theme.zIndex.carousel + 1 // bring the image in front of the carousel
  },
  contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: MAX_IMAGE_WIDTH,
      margin: [0, 'auto'],
      height: '100%',
      [theme.breakpoint("tablet")]: {
          margin: ({item: {image_location}}) => image_location === 'Right' ? '0 0 0 auto' : '0 auto 0 0'
      }
  },
  imageContainer: {
      maxWidth: MAX_IMAGE_WIDTH,
      margin: [0, 'auto', theme.spacing.small],
      [theme.breakpoint("tablet")]: {
          margin: ({item: {image_location}}) => image_location === 'Right' ? '0 auto 0 30px' : '0 30px 0 auto'
      }
  },
  title: {
      fontWeight: "normal",
      fontFamily: "Didot, serif",
      fontSize: theme.getRemValue(16),
      textTransform: "uppercase",
      lineHeight: 1.5,
      marginBottom: '1rem',
      [theme.breakpoint("mobile")]: {
          fontSize: theme.getRemValue(18),
      },
      [theme.breakpoint("tablet")]: {
          fontSize: theme.getRemValue(23),
      },
  },
  titleMobile: {
      [theme.breakpoint("tablet")]: {
          display: 'none'
      }
  },
  titleDesktop: {
      display: 'none',
      [theme.breakpoint("tablet")]: {
          display: 'block'
      }
  },
  body: {
      flex: 1
  },
  imageAboveContainer: {
    maxWidth: '100% !important',
    padding: [0, theme.spacing.tiny],
    [theme.breakpoint('mobile')]: {
      padding: 0
    },
  },
  imageAbove: {
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: 0,
    [theme.breakpoint('tablet')]: {
        maxWidth: '100%'
    },
    [theme.breakpoint('laptop')]: {
        padding: [0, theme.spacing.tiny],
        maxWidth: ({item: {image_size}}) => image_size ? image_size : '100%'
    },
    '& *': {
      maxWidth: '100% !important'
    }
  }
}))(ShopTheLookSlice)



// WEBPACK FOOTER //
// ./src/components/Article/ShopTheLookSlice.js